import React from 'react'

import style from './style.module.scss'

function Loader() {
  return <div className={style.wrapper} />
}

export default Loader
